<template>
    <div class="date date--range">
        <el-popover :value="errorsNotifier.start.isError"
                    trigger="manual"
                    placement="top"
                    width="150"
                    popper-class="add__error-popover"
                    :content="errorsNotifier.start.message">
            <el-date-picker
                slot="reference"
                v-model="dateFrom"
                class="date__picker"
                :class="{ 'add__error': errorsNotifier.start.isErrorPaint }"
                type="date"
                :clearable="false"
                :picker-options="pickerOptions"
                format="dd.MM.yyyy"
                v-mask="'##.##.####'"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="00.00.0000">
            </el-date-picker>
        </el-popover>
        <span class="date__separator"></span>
        <el-popover :value="errorsNotifier.end.isError"
                    trigger="manual"
                    placement="top"
                    width="150"
                    popper-class="add__error-popover"
                    :content="errorsNotifier.end.message">
            <el-date-picker
                slot="reference"
                v-model="dateTo"
                class="date__picker"
                :class="{ 'add__error': errorsNotifier.end.isErrorPaint }"
                type="date"
                :clearable="false"
                :picker-options="pickerOptions"
                format="dd.MM.yyyy"
                v-mask="'##.##.####'"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="00.00.0000">
            </el-date-picker>
        </el-popover>
    </div>
</template>

<script>
import datepicker from "../mixins/datepicker";
import {mask} from "vue-the-mask";
import errors from "../mixins/errors";

export default {
    name: "DateInterval",
    mixins: [datepicker, errors],
    directives: {mask},
    props: {
        value: {
            type: Object,
            required: true
        },
        keyForStart: {
            type: String,
            default: 'start'
        },
        keyForEnd: {
            type: String,
            default: 'end'
        },
        errorsNotifier: {
            type: Object,
            default: () => ({
                start: {
                    isError: false,
                    message: ''
                },
                end: {
                    isError: false,
                    message: ''
                },
            })
        }
    },
    data: () => ({
        dateFrom: '',
        dateTo: ''
    }),
    watch: {
        value: {
            handler(val) {
                this.dateFrom = val[this.keyForStart];
                this.dateTo = val[this.keyForEnd];
            },
            deep: true
        },
        dateFrom: {
            handler(val) {
                this.$emit('input', this.getCurrentValue());
            },
            deep: true
        },
        dateTo: {
            handler(val) {
                this.$emit('input', this.getCurrentValue());
            },
            deep: true
        }
    },
    methods: {
        getCurrentValue() {
            this.value[this.keyForStart] = this.dateFrom;
            this.value[this.keyForEnd] = this.dateTo;

            return this.value;
        }
    }
}
</script>

<style scoped>

</style>
